module.exports = __webpack_public_path__ + "static/media/alarm-plus.75870bb3.svg";